import type {
  BreadcrumbProps
} from '@chakra-ui/react'
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Container,
} from '@chakra-ui/react'
import { Link } from 'react-router-dom'

export interface BreadcrumbsProps extends BreadcrumbProps {
  items?: BreadcrumbItems
}

export type BreadcrumbItems = {
  to?: string
  label: string
  current?: boolean
}[]

export const Breadcrumbs = ({ items, ...rest }: BreadcrumbsProps) => {
  return items?.length ? (
    <Breadcrumb as={Container} py={2} {...rest}>
      {items.map(({ to, label, current }) => (
        <BreadcrumbItem key={to + label} isCurrentPage={!!current}>
          {current ? (
            <BreadcrumbLink whiteSpace='pre-wrap'>{label}</BreadcrumbLink>
          ) : (
            <BreadcrumbLink as={Link} to={to} whiteSpace='pre-wrap'>
              {label}
            </BreadcrumbLink>
          )}
        </BreadcrumbItem>
      ))}
    </Breadcrumb>
  ) : null
}
